import { BaseTable } from '@sede-enterprise/shell-ds-react-framework';
import styled from 'styled-components';
import { IDealDetails, TransformedDataEntry } from '../../../../types/types';
import { getTableData } from '../DealDetailFunctions';
import { TECH_SOURCE_COLUMN_POWER } from '../../../../api/constants';

const ModalFieldsTable = (props: { dealDetailsData: IDealDetails[]; years: string[] }) => {
  const { dealDetailsData, years } = props;
  const Container = styled.div`
    overflow: scroll;
  `;
  
  // Check if EVP is T&S Products
  const isTSProducts = dealDetailsData[0].EVP_NAME?.toLowerCase().replace(/[^a-z0-9]/g, '') === 'tsproducts';
  
  const techSource = isTSProducts
    ? `Products, ${dealDetailsData[0].QUANTITY_UNIT}`
    : dealDetailsData[0].TRADE_COMMODITY_NAME?.toLowerCase() === 'power'
    ? `${TECH_SOURCE_COLUMN_POWER}, ${dealDetailsData[0].QUANTITY_UNIT}`
    : `Tech Source, ${dealDetailsData[0].QUANTITY_UNIT}`;
    
  const cols = [techSource, ...years].map((val) => {
    return {
      accessorKey: val,
      header: val,
    };
  });

  const data: TransformedDataEntry[] = getTableData(dealDetailsData, cols);
  return (
    <Container>
      <BaseTable
        style={{ width: '100%' }}
        size='small'
        noFooter
        maxHeight={1000}
        columns={cols}
        data={data}
      />
    </Container>
  );
};

export default ModalFieldsTable;
